<template>
  <div class="scrollbar-hide relative -ml-4 w-screen sm:-ml-6 md:-ml-6 lg:w-full lg:ml-0">
    <div
      class="pointer-events-none absolute bottom-0 right-0 top-0 z-10 w-10 bg-gradient-to-r from-transparent to-brand-background"
      :class="` min-[${hiddenShadow}px]:hidden`"
    ></div>
    <slot name="list"></slot>
  </div>
</template>

<script setup>
defineProps({
  hiddenShadow: {
    type: Number,
    default: 0,
  },
});
</script>
